import type { HomePrescriptionItem, OptimisticPendingTransfer } from 'src/app/types';

import { AnimatedCard } from '../../../Elements/Animation/AnimatedCard';

import { HeadingTwo, SmallMedNameTitle, Subtitle, SubtitleBlock } from './styles';

interface PendingMedicationProps {
  homePrescriptionItem: HomePrescriptionItem | OptimisticPendingTransfer;
  showPendingText?: boolean;
}

const PendingMedication = ({ homePrescriptionItem, showPendingText = true }: PendingMedicationProps) => {
  const isDoctorCard = homePrescriptionItem.source === 'doctor';

  return (
    <AnimatedCard variant={'condensed'}>
      {showPendingText ? (
        <>
          <HeadingTwo data-cy="medication-name">{homePrescriptionItem.name}</HeadingTwo>
          <Subtitle maxWidthDesktop={isDoctorCard ? '90%' : undefined}>
            {isDoctorCard ? 'Retrieving from your Doctor.' : 'Transferring from your past pharmacy.'}{' '}
            <SubtitleBlock>This usually takes 1–2 days.</SubtitleBlock>
          </Subtitle>
        </>
      ) : (
        <SmallMedNameTitle data-cy="medication-name">{homePrescriptionItem.name}</SmallMedNameTitle>
      )}
    </AnimatedCard>
  );
};

export { PendingMedication };
